import { FC } from 'react';

import AddBoardsDocumentSectionHeader from './components/AddBoardsDocumentsSectionHeader';
import AddBoardsDocumentSectionBody from './components/AddBoardsDocumentsSectionBody';

type AddBoardsDocumentsSectionProps = {
  files: File[];
  onChangeFiles: (files: File[]) => void; // eslint-disable-line
  onRemoveFile: (index: number) => void; // eslint-disable-line
};

const AddBoardsDocumentSection: FC<AddBoardsDocumentsSectionProps> = ({
  files,
  onChangeFiles,
  onRemoveFile,
}) => (
  <>
    <AddBoardsDocumentSectionHeader onChangeFiles={onChangeFiles} />
    <AddBoardsDocumentSectionBody
      files={files}
      handleRemoveFile={onRemoveFile}
    />
  </>
);

export default AddBoardsDocumentSection;
